import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, DoCheck, forwardRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { isUndefined, isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import { RemunerationOtherParent } from '../RemunerationsShared/remuneration-other-table-edit.component';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '../../../_infrastructure/ValidationMessages/ExternalValidationDirective';
import { confirmRemoveFromList }  from '../../../_infrastructure/TableEdit/TableEditBase';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import { WorkflowComponent } from '../../workflow.component';
import { SubscriberInformationService } from '../../../_infrastructure/SubscriberInfo/SubscriberInformationService';
import { StepDetailsService } from '../../../_infrastructure/StepDetailsService/StepDetailsService';
//import DateHelpers from '../../../_infrastructure/DateHelpers';
import { CurrencyFormat } from '../../../_infrastructure/objectUtils';

@Component({
    selector: 'remunerations-current-monthly',
    templateUrl: './remunerations-current-monthly.component.html',
    providers: [{ provide: RemunerationOtherParent, useExisting: forwardRef(() => RemunerationsCurrentMonthlyComponent) },
        { provide: ICardComponentInjectionToken, useExisting: forwardRef(() => RemunerationsCurrentMonthlyComponent) }],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})

export class RemunerationsCurrentMonthlyComponent implements OnInit, OnDestroy, ICardComponent, DoCheck, RemunerationOtherParent {
  public cardData: models.RemunerationsCurrentMonthlyVM = {} as models.RemunerationsCurrentMonthlyVM;
  public cardConfiguration: models.CardVM;
  public isWorkflowOnSubscriber: boolean = false;
  public disableTableRemoveIcons: boolean = false;

  public expandedRowIndex: number = null;
  public expandNewEntry: boolean = false;
  public parentWorkflow: WorkflowComponent;
  public professionalClass: string;
  public subscriberType: string;
  public workflowDropdowns: models.WorkflowDropdownsVM = <models.WorkflowDropdownsVM>{};
  public subscriber: models.SubscriberInformationVM;
  public profGroup: string;
  public profClass: string;
  public profLevel: string;
  public levels: any[];
  public categories: {}[];
  public chosenCategory: {};
  public taxIndexes: {}[];
  public taxSteps: {}[];
  public isExSubscritor: boolean;
  public dataCessacao: Date = new Date();

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];

  constructor(private http: HttpClient, private activeRoute: ActivatedRoute, private modalService: ModalService, private subscriberInfoService: SubscriberInformationService) {
  }

  ngOnInit(): void {
    //TEMP to prevent undefined errors if no stepdata is found
    if (isNullOrUndefined(this.cardData.remunerationsList))
      this.cardData.remunerationsList = [];
    if (this.isVersion2()) {
      this.workflowDropdowns = this.parentWorkflow.workflowDropdowns;

      const haDataCessacao = this.checkSteps() ? this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.['dataCessacao'] : this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.['dataCessacao'];
      if (haDataCessacao !== null && haDataCessacao !== undefined) {
        this.dataCessacao = new Date(haDataCessacao);
      } else {
        this.dataCessacao = new Date("2006-01-02");
      }

      if (!this.checkSteps()) {
        this.professionalClass = this.parentWorkflow.workflowInstance.formData.StepSubscriberInfo && this.parentWorkflow.workflowInstance.formData.StepSubscriberInfo['CGAPensionStatus']?.professionalCategoryCode;
        this.subscriberType = this.parentWorkflow.workflowInstance.formData.StepSubscriberInfo && this.parentWorkflow.workflowInstance.formData.StepSubscriberInfo['CGAPensionStatus'].subscriberTypeCode;
      } else {
        this.professionalClass = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.professionalCategoryCode;
        this.subscriberType = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode;
      }

      this.isExSubscritor = (this.parentWorkflow.workflowInstance.workflowCode.indexOf('PEDI008') == -1 && this.parentWorkflow.workflowInstance.workflowCode.indexOf('PEDI005') == -1) ? false : true;

      //if (isNullOrUndefined(this.cardData.categoryM) && (this.checkCGDStarterEntity() || !this.checkIfMagDipMil())) {
      if (isNullOrUndefined(this.cardData.categoryM) &&
        (
          (!this.isExSubscritor && (this.checkCGDStarterEntity() || !this.checkIfMagDipMil()))
          //|| (this.isExSubscritor) //PIT39631
        )) {
        this.cardData.categoryM = this.getEffMapLastCategory();
      }
      else {
        this.checkCategoryM();
      }
      this.levels = this.getTaxLevelsM();

      if (!isNullOrUndefined(this.cardData.taxLevelM))
        this.changedTaxLevelsM(this.cardData.taxLevelM);
    }
  }

  ngDoCheck(): void {
    //Needs to be done in DoCheck because of step data being received asyncrously
    if (isNullOrUndefined(this.cardData.remunerationsList))
      this.cardData.remunerationsList = [];

    if (this.isVersion2()) {
      if (isNullOrUndefined(this.categories)) {
        //this.parentWorkflow.workflowDropdowns;
        this.categories = this.getCategoriesM();
        this.changedCategoryM(this.cardData.categoryM);
      }
      if (isNullOrUndefined(this.taxIndexes)) {
        //this.parentWorkflow.workflowDropdowns;
        this.taxIndexes = this.getTaxIndexesM();
        this.changedTaxIndexesM(this.cardData.taxIndexM);
      }
      if (isNullOrUndefined(this.taxSteps)) {
        //this.parentWorkflow.workflowDropdowns;
        this.taxSteps = this.getTaxStepsM();
      }

      this.isExSubscritor = (this.parentWorkflow.workflowInstance.workflowCode.indexOf('PEDI008') == -1 && this.parentWorkflow.workflowInstance.workflowCode.indexOf('PEDI005') == -1) ? false : true;

      if (!this.checkSteps()) {
        if (isNullOrUndefined(this.professionalClass)) {
          this.professionalClass = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.professionalCategoryCode;
        }
        if (isNullOrUndefined(this.subscriberType)) {
          this.subscriberType = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
        }
      } else {
        if (isNullOrUndefined(this.professionalClass))
          this.professionalClass = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.professionalCategoryCode;
        if (isNullOrUndefined(this.subscriberType))
          this.subscriberType = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode;
      }
    }
  }

  ngOnDestroy(): void {
  }


  isVersion2() {
    let result = false;
    if (this.parentWorkflow.workflowInstance.formData['Version']?.toString() === '2') {
      result = true;
    }
    return result;
  }

  hasChristmasBenefitChanged() {
    if (this.cardData.hasChristmasBenefit === 'false') {
      this.cardData.christmasBenefitAmount = null;
    }
  }

  checkSteps() {
    let result = false;
    for (let i = 0; i < this.parentWorkflow.steps.length; i++) {
      if (this.parentWorkflow.steps[i].stepCode === "StepSubscriberCGA") {
        result = true;
        break;
      }
    }
    return result;
  }

  checkIfMagDip() {
    let result = false;
    let profCats = ['4', '5'];
    if (profCats.indexOf(this.professionalClass) >= 0)
      result = true

    return result;
  }

  checkIfMagDipMil() {
    let result = false;
    let isMagDipMil = false;
    let profCats = ['4', '5', '17'];
    if (profCats.indexOf(this.professionalClass) >= 0)
      result = true;
    return result;
  }

  checkCGDStarterEntity() {
    let result = false;
    if (this.parentWorkflow.workflowInstance.formData['StepServiceInfo']?.['ServiceIdentification']?.code === '2251') {
      result = true
    }
    return result;
  }

  getEffMapLastCategory() {
    let result;

    let effMapEntries: models.EffectivityEntryVM[] = this.parentWorkflow.workflowInstance.formData['StepMap']?.['EffectivityMap']?.['effectivityList'];
    if (effMapEntries?.length > 0) {
      result = effMapEntries[effMapEntries.length - 1]
    }
    return result?.['category'];
  }

  getEffMapLastEndDate() {
    let result;

    let effMapEntries: models.EffectivityEntryVM[] = this.parentWorkflow.workflowInstance.formData['StepMap']?.['EffectivityMap']?.['effectivityList'];
    if (effMapEntries?.length > 0) {
      result = effMapEntries[effMapEntries.length - 1]
    }

    return result?.['endDate'];
  }

  onRemunerationsListChanged(newList: models.RemunerationOtherVM[]) {
    this.sortListByStartDate(newList);
    this.cardData.remunerationsList = newList;
    this.expandedRowIndex = null;
    this.expandNewEntry = false;
  }
  removeFromList(currentList: any[], indexToRemove: number, event: MouseEvent) {
    if (this.expandedRowIndex == null || this.expandedRowIndex == indexToRemove) {
      confirmRemoveFromList(currentList, indexToRemove, this.modalService).subscribe(result => {
        if (result)
          this.expandedRowIndex = null;
      });
    }
    event.stopPropagation();
  }
  expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
  }

  sortListByStartDate(remunerationsList: models.RemunerationOtherVM[]) {
    remunerationsList.sort((first, second) => first.startDate?.getTime() - second.startDate?.getTime());
  }

  getTaxStepsM() {
    if (this.professionalClass === "4") {
      this.profClass = "DIPL";
      if (!this.checkCGDStarterEntity())
        this.profGroup = "1";
    } else if (this.professionalClass === "5") {
      this.profClass = "MAJ";
      if (!this.checkCGDStarterEntity())
        this.profGroup = "1";
    } else if (this.professionalClass === "17") {
      this.profClass = "MIL";
      if (!this.checkCGDStarterEntity())
        this.profGroup = "11";
    }

    if (this.checkCGDStarterEntity()) {
      this.profClass = "CGD";
    }
    let result = [];
    if (!this.checkCGDStarterEntity()) {
      let today = new Date();
      for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
        if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === "dropListEscalao") {
          if (this.parentWorkflow.workflowDropdowns.options[i]['filter3'] === this.profClass) {
            if (this.parentWorkflow.workflowDropdowns.options[i]['type'] === this.chosenCategory?.['value']) {
              if (this.parentWorkflow.workflowDropdowns.options[i]['filter'] === this.profGroup) {
                if (new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter2']) >= today && this.profClass === "MAJ") {
                  result.push(this.parentWorkflow.workflowDropdowns.options[i]);
                } else if (new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter2']).getTime() >= today.getTime() && new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter4']).getTime() <= today.getTime() && this.profClass === "DIPL") {
                  result.push(this.parentWorkflow.workflowDropdowns.options[i]);
                } else if (this.profClass !== "MAJ" && this.profClass !== "DIPL") {
                  result.push(this.parentWorkflow.workflowDropdowns.options[i]);
                }
              }
            }
          }
        }
      }
    } else {
      for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
        if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === "dropListNivel") {
          if (this.parentWorkflow.workflowDropdowns.options[i]['type'] === this.cardData.taxLevelM)
            result.push(this.parentWorkflow.workflowDropdowns.options[i]);
        }
      }
    }

    result.sort((a, b) => a.type.localeCompare(b.type, undefined, { numeric: true }));

    return result;
  }

  changedTaxSteps(e) {
    if (!this.checkCGDStarterEntity()) {
      //this.taxSteps = this.getTaxStepsM();
      this.taxIndexes = this.getTaxIndexesM();
    }
  }

  getTaxLevelsM() {
    let result = [];
    let today: Date = new Date();
    for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
      if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === "dropListSuperiorNivel") {
        if (new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter']) >= today)
          result.push(this.parentWorkflow.workflowDropdowns.options[i]);
      }
    }
    result.sort((a, b) => a.description.localeCompare(b.description, undefined, { numeric: true }));

    return result;
  }

  changedTaxLevelsM(e) {
    this.profLevel = e;
    for (let i = 0; i < this.levels.length; i++) {
      if (this.levels[i]['value'] === e) {
        this.profGroup = this.levels[i]['type'];
      }
    }

    this.taxSteps = this.getTaxStepsM();
  }


  getTaxIndexesM() {
    if (this.professionalClass === "4") {
      this.profClass = "DIPL";
      this.profGroup = '1';
    } else if (this.professionalClass === "5") {
      this.profClass = "MAJ";
      this.profGroup = '1';
    } else if (this.professionalClass === "17") {
      this.profClass = "MIL";
      this.profGroup = '11';
    }
    let result = [];
    let today = new Date();
    for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
      if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === "dropListIndice") {
        if (this.parentWorkflow.workflowDropdowns.options[i]['value'] === this.profClass) {
          if (this.parentWorkflow.workflowDropdowns.options[i]['type'] === this.chosenCategory?.['value']) {
            if (this.parentWorkflow.workflowDropdowns.options[i]['filter'] === this.profGroup) {
              if (this.parentWorkflow.workflowDropdowns.options[i]['filter4'] === this.cardData.earningsTableIndexM) {
                if (new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter2']) >= today && this.profClass === "MAJ") {
                  result.push(this.parentWorkflow.workflowDropdowns.options[i]);
                } else if (new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter2']).getTime() >= today.getTime() && new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter3']).getTime() <= today.getTime() && this.profClass === "DIPL") {
                  result.push(this.parentWorkflow.workflowDropdowns.options[i]);
                } else if (this.profClass !== "MAJ" && this.profClass !== "DIPL") {
                  result.push(this.parentWorkflow.workflowDropdowns.options[i]);
                }
              }
            }
          }
        }
      }
    }

    result.sort((a, b) => a.description.localeCompare(b.description, undefined, { numeric: true }));

    return result;
  }

  changedTaxIndexesM(e) {
    //this.taxSteps = this.getTaxStepsM();
  }

  getCategoriesM() {
    if (this.professionalClass === "4") {
      this.profClass = "DIPL";
      this.profGroup = "1";
    } else if (this.professionalClass === "5") {
      this.profClass = "MAJ";
      this.profGroup = "1";
    } else if (this.professionalClass === "17") {
      this.profClass = "MIL";
      this.profGroup = "11";
    }
    let result = [];
    if (this.profClass === "MIL") {
      for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
        if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === "dropListSuperiorMIL") {
          result.push(this.parentWorkflow.workflowDropdowns.options[i]);
        }
      }
    } else if (this.profClass === "DIPL") {
      let lastEffMapEntry: Date = this.getEffMapLastEndDate();
      for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
        if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === "dropListDipl") {
          if (new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter']).getTime() >= lastEffMapEntry.getTime() && lastEffMapEntry.getTime() >= new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter2']).getTime())
            result.push(this.parentWorkflow.workflowDropdowns.options[i]);
        }
      }
    } else if (this.profClass === "MAJ") {
      let lastEffMapEntry: Date = this.getEffMapLastEndDate();
      for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
        if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === "dropListMaj") {
          if (new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter']) >= lastEffMapEntry)
            result.push(this.parentWorkflow.workflowDropdowns.options[i]);
        }
      }
    }

    if (this.profClass === "MIL" || this.profClass === "DIPL" || this.profClass === "MAJ")
      result = result.filter(taxIndex => taxIndex['type'] === this.profGroup);
    return result;
  }

  changedCategoryM(e) {
    if (this.checkIfMagDip()) {
      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i]['description'] === e) {
          this.chosenCategory = this.categories[i];
        }
      }
      //this.taxIndexes = this.getTaxIndexesM();
      this.taxSteps = this.getTaxStepsM();
    }
  }

  public currencyFormat(value) {
    return CurrencyFormat(value);
  }

  //RemunerationPosition
  checkVisibilityRemunerationPosition() {
    if (!this.isExSubscritor) {
      if (!this.checkIfMagDip() && !this.checkCGDStarterEntity()) {
        return true;
      }
      else {
        this.cardData.remunerationPosition = undefined;
        return false;
      }
    }
    else {
      let date2008 = new Date("2008-12-31T23:59:59");
      let date2009 = new Date("2009-12-31T23:59:59");

      var subscriberType: any;
      subscriberType = this.checkSteps() ? this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode : this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
      // 01 civil    // 02 Militar    // 03 Militarizado

      //Civil (excluindo pedidos cujo serviço responsável é a CGD e ex-subscritores cuja classe profissional é Magistrados ou Corpos diplomáticos
      if (subscriberType == '01' && (!this.checkIfMagDip() && !this.checkCGDStarterEntity()) && this.dataCessacao <= date2008) {
        this.cardData.remunerationPosition = undefined;
        return false;
      }

      //Militar - Militarizado
      if ((subscriberType == '02' || subscriberType == '03') && this.dataCessacao <= date2009) {
        this.cardData.remunerationPosition = undefined;
        return false;
      }

      //Civil - Magistrados judiciais e do ministério público / Corpos diplomáticos
      if (subscriberType == '01' && this.checkIfMagDip()) {
        this.cardData.remunerationPosition = undefined;
        return false;
      }

      // "Civis Serviço responsável pelo pedido = CGD"
      if (subscriberType == '01' && !this.checkIfMagDip() && this.checkCGDStarterEntity()) {
        this.cardData.remunerationPosition = undefined;
        return false;
      }
    }

    return true;
  }

  //remunerationLevel
  checkVisibilityRemunerationLevel() {

    if (!this.isExSubscritor) {
      if (!this.checkIfMagDip() && !this.checkCGDStarterEntity()) {
        return true;
      }
      else {
        this.cardData.remunerationLevel = undefined;
        return false;
      }
    }
    else {
      let date2008 = new Date("2008-12-31T23:59:59");
      let date2009 = new Date("2009-12-31T23:59:59");

      var subscriberType: any;
      subscriberType = this.checkSteps() ? this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode : this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
      // 01 civil    // 02 Militar    // 03 Militarizado

      //Civil (excluindo pedidos cujo serviço responsável é a CGD e ex-subscritores cuja classe profissional é Magistrados ou Corpos diplomáticos
      if (subscriberType == '01' && (!this.checkIfMagDip() && !this.checkCGDStarterEntity()) && this.dataCessacao <= date2008) {
        this.cardData.remunerationLevel = undefined;
        return false;
      }

      //Militar - Militarizado
      if ((subscriberType == '02' || subscriberType == '03') && this.dataCessacao <= date2009) {
        this.cardData.remunerationLevel = undefined;
        return false;
      }

      //Civil - Magistrados judiciais e do ministério público / Corpos diplomáticos
      if (subscriberType == '01' && this.checkIfMagDip()) {
        this.cardData.remunerationLevel = undefined;
        return false;
      }

      // "Civis Serviço responsável pelo pedido = CGD"
      if (subscriberType == '01' && !this.checkIfMagDip() && this.checkCGDStarterEntity()) {
        this.cardData.remunerationLevel = undefined;
        return false;
      }
    }

    return true;
  }

  //baseRevenue -- Always visible
  //christmasBenefitAmount  -- Always visible
  //categoryM -- Always visible


  //taxLevelM
  checkVisibilityTaxLevelM() {

    if (!this.isExSubscritor) {
      return true;
    }
    else {
      var subscriberType: any;
      subscriberType = this.checkSteps() ? this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode : this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
      // 01 civil    // 02 Militar    // 03 Militarizado

      //Civil (excluindo pedidos cujo serviço responsável é a CGD e ex-subscritores cuja classe profissional é Magistrados ou Corpos diplomáticos
      if (subscriberType == '01' && (!this.checkIfMagDip() && !this.checkCGDStarterEntity())) {
        this.cardData.taxLevelM = undefined;
        return false;
      }
        
      //Militar - Militarizado
      if ((subscriberType == '02' || subscriberType == '03')) {
        this.cardData.taxLevelM = undefined;
        return false;
      }

      //Civil - Magistrados judiciais e do ministério público / Corpos diplomáticos
      if (subscriberType == '01' && this.checkIfMagDip()) {
        this.cardData.taxLevelM = undefined;
        return false;
      }
    }

    return true;
  }

  //earningsTableIndexM
  checkVisibilityEarningsTableIndexM() {

    if (!this.isExSubscritor) {
      return true;
    }
    else {
      let date1989 = new Date("1989-09-30T23:59:59");
      let date2008 = new Date("2008-12-31T23:59:59");
      let date2009 = new Date("2009-12-31T23:59:59");

      var subscriberType: any;
      subscriberType = this.checkSteps() ? this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode : this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
      // 01 civil    // 02 Militar    // 03 Militarizado

      //Civil (excluindo pedidos cujo serviço responsável é a CGD e ex-subscritores cuja classe profissional é Magistrados ou Corpos diplomáticos
      if (subscriberType == '01' && (!this.checkIfMagDip() && !this.checkCGDStarterEntity()) && (this.dataCessacao <= date1989 || this.dataCessacao > date2008)) {
        this.cardData.earningsTableIndexM = undefined;
        return false;
      }
        
      //Militar - Militarizado
      if ((subscriberType == '02' || subscriberType == '03') && (this.dataCessacao <= date1989 || this.dataCessacao > date2009)) {
        this.cardData.earningsTableIndexM = undefined;
        return false;
      }

      //Civil - Magistrados judiciais e do ministério público / Corpos diplomáticos
      if (subscriberType == '01' && this.checkIfMagDip() && this.dataCessacao <= date1989) {
        this.cardData.earningsTableIndexM = undefined;
        return false;
      }
    }

    return true;
  }

  //taxIndexM
  checkVisibilityTaxIndexM() {

    if (!this.isExSubscritor) {
      return true;
    }
    else {
      let date1989 = new Date("1989-09-30T23:59:59");
      let date2008 = new Date("2008-12-31T23:59:59");
      let date2009 = new Date("2009-12-31T23:59:59");

      var subscriberType: any;
      subscriberType = this.checkSteps() ? this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode : this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
      // 01 civil    // 02 Militar    // 03 Militarizado

      //Civil (excluindo pedidos cujo serviço responsável é a CGD e ex-subscritores cuja classe profissional é Magistrados ou Corpos diplomáticos
      if (subscriberType == '01' && (!this.checkIfMagDip() && !this.checkCGDStarterEntity()) && (this.dataCessacao <= date1989 || this.dataCessacao > date2008)) {
        this.cardData.taxIndexM = undefined;
        return false;
      }

      //Militar - Militarizado
      if ((subscriberType == '02' || subscriberType == '03') && (this.dataCessacao <= date1989 || this.dataCessacao > date2009)) {
        this.cardData.taxIndexM = undefined;
        return false;
      }

      //Civil - Magistrados judiciais e do ministério público / Corpos diplomáticos
      if (subscriberType == '01' && this.checkIfMagDip() && this.dataCessacao <= date1989) {
        this.cardData.taxIndexM = undefined;
        return false;
      }

      //"Civis Serviço responsável pelo pedido = CGD"
      if (subscriberType == '01' && !this.checkIfMagDip() && this.checkCGDStarterEntity()) {
        this.cardData.taxIndexM = undefined;
        return false;
      }
    }

    return true;
  }

  //letter (Novo)
  checkVisibilityLetter() {

    if (!this.isExSubscritor) {
      return true;
    }
    else {
      let date1989 = new Date("1989-09-30T23:59:59");

      var subscriberType: any;
      subscriberType = this.checkSteps() ? this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode : this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
      // 01 civil    // 02 Militar    // 03 Militarizado

      //Civil (excluindo pedidos cujo serviço responsável é a CGD e ex-subscritores cuja classe profissional é Magistrados ou Corpos diplomáticos
      if (subscriberType == '01' && (!this.checkIfMagDip() && !this.checkCGDStarterEntity()) && this.dataCessacao > date1989) { 
        this.cardData.letter = undefined;
        return false;
      }

      //Militar - Militarizado
      if ((subscriberType == '02' || subscriberType == '03') && this.dataCessacao > date1989) {
        this.cardData.letter = undefined;
        return false;
      }

      //Civil - Magistrados judiciais e do ministério público / Corpos diplomáticos
      if (subscriberType == '01' && this.checkIfMagDip() && this.dataCessacao > date1989) {
        this.cardData.letter = undefined;
        return false;
      }

      // "Civis Serviço responsável pelo pedido = CGD"
      if (subscriberType == '01' && !this.checkIfMagDip() && this.checkCGDStarterEntity()) {
        this.cardData.letter = undefined;
        return false;
      }
    }

    return true;
  }

  checkCategoryM() {

    if (this.isExSubscritor && isNullOrUndefined(this.cardData.categoryM)) {
      var isValid: any;
      isValid = false;

      var subscriberType: any;
      subscriberType = this.checkSteps() ? this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode : this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
      // 01 civil    // 02 Militar    // 03 Militarizado

      this.cardData.categoryM = this.getEffMapLastCategory();
      //Civil (excluindo pedidos cujo serviço responsável é a CGD e ex-subscritores cuja classe profissional é Magistrados ou Corpos diplomáticos
      if (subscriberType == '01' && (!this.checkIfMagDip() && !this.checkCGDStarterEntity()))
        isValid = true;

      //Militar - Militarizado
      if ((subscriberType == '02' || subscriberType == '03'))
        isValid = true;

      //Civil - Magistrados judiciais e do ministério público / Corpos diplomáticos
      if (subscriberType == '01' && this.checkIfMagDip())
        isValid = true;

      //"Civis Serviço responsável pelo pedido = CGD"
      if (subscriberType == '01' && !this.checkIfMagDip() && this.checkCGDStarterEntity())
        isValid = true;

      if (isValid)
        this.cardData.categoryM = this.getEffMapLastCategory();
    }
  }
}
